export const zoneColors = {
    good: "#5db85b",
    warning: "#f3a739",
    bad: "#e73b3b",
    low: "#a1dab4",
    med: "#41b6c4",
    high: "#3562a8",
};
export const zoneNames = {
    good: "Good",
    warning: "Needs Improvement",
    bad: "Poor",
    low: "Low",
    med: "Medium",
    high: "High",
};
export function getThresholdValue(threshold) {
    if (typeof threshold.value === "number") {
        return threshold.value;
    }
    return Infinity;
}
export function getThresholdColor(threshold) {
    return zoneColors[threshold.type];
}
export function getThresholdName(thresholds, threshold, suffixProp) {
    const suffix = suffixProp ? suffixProp : "";
    //Find index of the threshold within all thresholds.
    const thresholdIndex = thresholds.findIndex((thresholdInd) => {
        if (thresholdInd.type === threshold.type) {
            return true;
        }
    });
    let thresholdName = zoneNames[threshold.type];
    if (thresholdIndex === 0) {
        thresholdName += " (<" + threshold.value + suffix + ")";
    }
    else if (thresholdIndex === 1) {
        thresholdName += " (" + thresholds[0].value + "-" + threshold.value + suffix + ")";
    }
    else {
        thresholdName += " (>" + thresholds[1].value + suffix + ")";
    }
    return thresholdName;
}
export function thresholdsToHighchartsZones(thresholds) {
    return thresholds
        .sort((a, b) => getThresholdValue(a) - getThresholdValue(b))
        .map((threshold) => ({
        color: getThresholdColor(threshold),
        value: getThresholdValue(threshold),
    }));
}
export function getThresholdForValue(thresholds, value) {
    const thresholdsSorted = thresholds.sort((a, b) => getThresholdValue(a) - getThresholdValue(b));
    for (let i = 0; i < thresholdsSorted.length; i++) {
        const thresholdValue = thresholdsSorted[i].value;
        if (thresholdValue) {
            if (value <= thresholdValue) {
                return thresholdsSorted[i];
            }
        }
    }
    return thresholdsSorted[thresholdsSorted.length - 1];
}
export function getThresholdsColorForValue(thresholds, value) {
    return getThresholdColor(getThresholdForValue(thresholds, value));
}
